module.exports = __webpack_public_path__ + "img/1602400674.fdb794cf.png";